export default "__VITE_ASSET__afb53989__"